import {Col, Container, Row} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {Rib} from '../../../interfaces/rib';
import {addSpacesToIBAN} from '../../../common/tools/iban';

interface DisplayRibInterfaceProps {
    rib: Rib;
}

const DisplayRibInterface = ({rib}: DisplayRibInterfaceProps): JSX.Element => {
    const intl = useIntl();

    const {owner, ibanPrefix, bankAccountNumber, bic, bank} = rib;

    return (
        <Container fluid={true}>
            <Row className="mb-5">
                <Col xs={12} className="bg-celeste-bg-secondary fs-5 fw-bold text-black p-3 ps-5">
                    {intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.ACCOUNT_HOLDER'})}
                </Col>
                <Col xs={12} className="text-black fs-6 fw-semibold text-gray-600 p-3 ps-5">
                    {owner}
                </Col>
            </Row>
            <Row className="mb-5">
                <Col xs={12} className="bg-celeste-bg-secondary fs-5 fw-bold text-black p-3 ps-5">
                    {intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.IBAN'})}
                </Col>
                <Col xs={12} className="text-black fs-6 fw-semibold text-gray-600 p-3 ps-5">
                    {`${ibanPrefix} ${addSpacesToIBAN(bankAccountNumber ?? '')}`}
                </Col>
            </Row>
            <Row className="mb-5">
                <Col xs={12} className="bg-celeste-bg-secondary fs-5 fw-bold text-black p-3 ps-5">
                    {intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.BIC'})}
                </Col>
                <Col xs={12} className="text-black fs-6 fw-semibold text-gray-600 p-3 ps-5">
                    {bic}
                </Col>
            </Row>
            <Row className="mb-5">
                <Col xs={12} className="bg-celeste-bg-secondary fs-5 fw-bold text-black p-3 ps-5">
                    {intl.formatMessage({
                        id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.BANK',
                    })}
                </Col>
                <Col xs={12} className="text-black fs-6 fw-semibold text-gray-600 p-3 ps-5">
                    {bank}
                </Col>
            </Row>
        </Container>
    );
};

export default DisplayRibInterface;
